// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template/src/index.tsx

import baseIcon, { navigationDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
var NavigationIconSpendingPowerPath = 'M10.776 4.267A8.741 8.741 0 0 1 22.3 4.074l.22.193.75.68-2.88 3.097A4.426 4.426 0 0 0 24.01 6.93l.165-.159 1.424 1.404a6.424 6.424 0 0 1-3.957 1.885c3.141 2.204 5.262 6.37 5.356 11.133l.003.331v1.91a3.54 3.54 0 0 1-3.317 3.559l-.217.007H3V17h3.664c1.135-3.905 3.69-6.899 6.859-8.07l-2.716-3.137-1.054-.599 1.023-.927ZM5 21h8v-2H5v2Zm10 0v4h8.464a1.54 1.54 0 0 0 1.53-1.404l.006-.155v-1.916c0-6.193-3.865-11.133-8.49-11.133-3.37 0-6.404 2.638-7.75 6.608H15v4Zm-2 4v-2H5v2h8Zm7.375-19.876-3.072 3.305a8.597 8.597 0 0 0-1.57-.002l-2.841-3.283.08-.055a6.745 6.745 0 0 1 7.352 0l.051.035Z';
var NavigationIconSpendingPower = baseIcon('NavigationIconSpendingPower', {
  getPath: () => NavigationIconSpendingPowerPath,
  defaultStyleSheetGetter: navigationDefaultStyleSheetGetter,
  groupProps: defaultNavigationIconGroupProps,
  shapeSize: defaultNavigationIconShapeSize
});
export default NavigationIconSpendingPower;
//# sourceMappingURL=index.js.map